@file:Suppress("EXPERIMENTAL_API_USAGE")

package com.downdogapp.client.api

import com.downdogapp.*
import kotlinx.serialization.Serializable
import kotlinx.serialization.decodeFromString
import kotlinx.serialization.encodeToString

/**
 * AUTO-GENERATED DO NOT EDIT!
 * from com.downdogapp.tasks.api.json.response.ClientResponsesFile
 */
// @formatter:off
interface Response {

  fun toJson(): String
}

@Serializable
data class AppLink(
  val link: Link = Link(),
  val appType: AppType = AppType.ORIGINAL) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): AppLink = JSON.decodeFromString(str)
  }
}

@Serializable
data class ChallengeEnrollResponse(
  val message: String = "") : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): ChallengeEnrollResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class ChromecastUrlsResponse(
  val videoUrl: String? = null,
  val subtitleUrl: String? = null,
  val errorMessage: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): ChromecastUrlsResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class ForgotPasswordResponse(
  val message: String = "") : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): ForgotPasswordResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class GiftProduct(
  val productId: String = "",
  val productTitle: String = "",
  val productSubtitle: String? = null,
  val currencyCode: String? = null,
  val price: String? = null,
  val appPrice: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): GiftProduct = JSON.decodeFromString(str)
  }
}

@Serializable
data class HistoryDetailsResponse(
  val poses: List<Pose> = listOf(),
  val songs: List<Song> = listOf()) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): HistoryDetailsResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class HistoryItem(
  val sequenceId: String = "",
  val displayStart: Boolean = false,
  val displaySave: Boolean = false,
  val displayPoses: Boolean = false,
  val displaySongs: Boolean = false,
  val primaryText: String = "",
  val date: String = "",
  val timestamp: Duration = Duration.ZERO,
  val practiceId: String = "",
  val appType: AppType = AppType.ORIGINAL,
  val settingTexts: List<String> = listOf(),
  val totalTime: Duration = Duration.ZERO,
  val proportionCompleted: Double = 0.0) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): HistoryItem = JSON.decodeFromString(str)
  }
}

@Serializable
data class HistoryResponse(
  val items: MutableList<HistoryItem> = mutableListOf(),
  val properties: Map<String, SequenceUserProperties> = mapOf()) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): HistoryResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class LanguageOption(
  val label: String = "",
  val value: Language = Language.ENGLISH) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): LanguageOption = JSON.decodeFromString(str)
  }
}

@Serializable
data class LatestPaymentResponse(
  val paymentId: String? = null,
  val alreadyRefunded: Boolean? = null,
  val apple: Boolean? = null,
  val monthly: Boolean? = null,
  val practicedSincePurchase: Boolean? = null,
  val purchaseNotRecent: Boolean? = null,
  val price: String? = null,
  val date: String? = null,
  val boughtWith: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): LatestPaymentResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class Link(
  val id: String? = null,
  val label: String = "",
  val urls: List<String> = listOf()) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): Link = JSON.decodeFromString(str)
  }
}

@Serializable
data class LoginResponse(
  val cred: String? = null,
  val title: String? = null,
  val message: String? = null,
  val type: LoginResponseType = LoginResponseType.SUCCESS) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): LoginResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class Manifest(
  val requestUrls: RequestUrls = RequestUrls(),
  val artworkUrlPrefix: String = "",
  val poseImageUrlPrefix: String = "",
  val poseLibraryUrlPrefix: String = "",
  val showPosesOnTimeline: Boolean = false,
  val shareUrl: String? = null,
  val practiceFeedbackMessage: Message? = null,
  val menuContactMessage: Message? = null,
  val supportLink: Link? = null,
  val requiredUpdateMessage: Message? = null,
  val displayChangeLanguage: Boolean = false,
  val displayLoginOnStart: Boolean = false,
  val displayAppleSignInButton: Boolean = false,
  val displayGoogleSignInButton: Boolean = false,
  val displayFacebookSignInButton: Boolean = false,
  val displayEnterCode: Boolean = false,
  val displayMembershipOnStartClicked: Boolean = false,
  val displayLoginMenuButton: Boolean = false,
  val displayLogoutMenuButton: Boolean = false,
  val displayFeedbackButtonOnPlayback: Boolean = false,
  val signUpTitle: String? = null,
  val signUpSubtitle: String? = null,
  val welcomeTitle: String? = null,
  val facebookLinked: Boolean = false,
  val googleLinked: Boolean = false,
  val appleLinked: Boolean = false,
  val hasPassword: Boolean = false,
  val displayNewPracticePage: Boolean = false,
  val displayHistoryPage: Boolean = false,
  val displayOfflinePracticesPage: Boolean = false,
  val displayFavoritesPage: Boolean = false,
  val displayStatsPage: Boolean = false,
  val newPracticePageTitle: String = "",
  val historyPageTitle: String = "",
  val offlinePracticesPageTitle: String = "",
  val favoritesPageTitle: String = "",
  val statsPageTitle: String = "",
  val menuPageTitle: String = "",
  val teaserOptionSelectedText: String = "",
  val castContentTitle: String = "",
  val castAsMp4: Boolean = false,
  val defaultAudioBalance: Double = 0.0,
  val defaultShowOverlay: Boolean = false,
  val defaultKeepTimelineVisible: Boolean = false,
  val defaultShowCountdown: Boolean = false,
  val defaultShowSubtitles: Boolean = false,
  val defaultDisplayPoseNames: Boolean = false,
  val defaultShowLikeAndExcludeButtons: Boolean = false,
  val pauseForSongLoading: Boolean = false,
  val autoUpdatePlaybackUrl: Boolean = false,
  val globalSongRewindLimit: Duration = Duration.ZERO,
  val loadingMessages: List<String> = listOf(),
  val loadingMessageStartTimes: List<Duration> = listOf(),
  val subscriptions: List<Subscription> = listOf(),
  val menuLinks: List<Link> = listOf(),
  val giftLink: Link? = null,
  val facebookCommunityUrl: String? = null,
  val instagramUrl: String? = null,
  val membershipButtonText: String? = null,
  val userStartDateText: String? = null,
  val languageOptions: List<LanguageOption> = listOf(),
  val defaultLanguage: Language = Language.ENGLISH,
  val videoQualities: List<VideoQuality> = listOf(),
  val defaultVideoQualityId: Int = 0,
  val likedStateLikedId: Int = 0,
  val likedStateDisikedId: Int = 0,
  val allPoseIds: List<Int> = listOf(),
  val selectorSections: List<SettingSelectorSection> = listOf(),
  val settingRoots: List<SettingNode> = listOf(),
  val mixGroups: List<MixGroup> = listOf(),
  val mixSubgroups: List<MixSubgroup> = listOf(),
  val mixPresets: List<MixPreset> = listOf(),
  val mixGroupNumIncrements: Int = 0,
  val onboardingConfig: OnboardingConfig? = null,
  val cred: String? = null,
  val menuRestorePurchaseText: String? = null,
  val membershipConfig: MembershipConfig = MembershipConfig(),
  val sequenceIdToResume: String? = null,
  val email: String? = null,
  val userId: String? = null,
  var receivingPromotionalEmails: Boolean = false,
  val webVersionUrl: String = "",
  val webVersionText: String = "",
  val appLinks: List<AppLink> = listOf(),
  val historyDeepLinks: List<AppLink> = listOf(),
  val enabledEventLoggingSubstrings: List<String> = listOf(),
  val defaultFirstDayOfWeekIsMonday: Boolean = false,
  val numRecentSettingsToShow: Int = 0,
  val startScreenPrimaryMessages: List<String> = listOf(),
  val sequenceLengthTypeId: Int = 0,
  val playlistSettingTypeIds: List<Int> = listOf(),
  val mixPresetTypeId: Int = 0,
  val customMixTypeId: Int = 0,
  val viewPosesTypeId: Int = 0,
  val maxConcurrentPracticeDownloads: Int = 0,
  val disableNewGoogleSignIn: Boolean = false) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): Manifest = JSON.decodeFromString(str)
  }
}

@Serializable
data class MembershipConfig(
  val title: String = "",
  val subtitle: String = "",
  val declineButtonText: String? = null,
  val extraTermsText: String? = null,
  val purchaseButtonText: String = "",
  val webPromoUrl: String? = null,
  val webPromoText: String? = null,
  val products: List<Product> = listOf(),
  val affordabilityMessage: Message? = null,
  val affordabilityLink: Link? = null,
  val defaultProductPeriod: ProductPeriod = ProductPeriod.MONTHLY,
  val defaultCurrencyCode: String? = null,
  val singleAppTiles: List<AppType> = listOf(),
  val yearlySavingsPercentageString: String? = null,
  val purchaseConfirmationText: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): MembershipConfig = JSON.decodeFromString(str)
  }
}

@Serializable
data class Message(
  val id: String? = null,
  val title: String? = null,
  val content: String? = null,
  val link: Link? = null,
  val displayFeedbackBox: Boolean = false,
  val feedbackHintText: String? = null,
  val continueButtonText: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): Message = JSON.decodeFromString(str)
  }
}

@Serializable
data class MessageResponse(
  val message: Message? = null,
  val survey: Survey? = null,
  val urlToOpen: String? = null,
  val displayMembership: Boolean = false) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): MessageResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class MixConfig(
  val groupIds: List<Int> = listOf(),
  val subgroupIds: List<Int> = listOf(),
  val presetIds: List<Int> = listOf()) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): MixConfig = JSON.decodeFromString(str)
  }
}

@Serializable
data class MixGroup(
  val id: Int = 0,
  val label: String = "") : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): MixGroup = JSON.decodeFromString(str)
  }
}

@Serializable
data class MixPreset(
  val id: Int = 0,
  val label: String = "",
  val mixGroupAmounts: Map<Int, Int> = mapOf(),
  val mixSubgroupsEnabled: List<Int> = listOf()) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): MixPreset = JSON.decodeFromString(str)
  }
}

@Serializable
data class MixSubgroup(
  val id: Int = 0,
  val label: String = "",
  val groupId: Int = 0) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): MixSubgroup = JSON.decodeFromString(str)
  }
}

@Serializable
data class OfflineUrlResponse(
  val url: String = "",
  val primaryText: String = "",
  val secondaryText: String = "") : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): OfflineUrlResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class OnboardingConfig(
  val showBeforeLogin: Boolean = false,
  val selectorItems: List<SettingSelectorItem> = listOf()) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): OnboardingConfig = JSON.decodeFromString(str)
  }
}

@Serializable
data class PlaybackUrlResponse(
  val url: String = "",
  val videoOffsetTime: Duration = Duration.ZERO) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): PlaybackUrlResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class Playlist(
  val playlistId: String = "",
  val songs: MutableList<Song> = mutableListOf(),
  val startTimes: MutableList<Duration> = mutableListOf(),
  val playlistTypeId: Int = 0,
  val disableSkip: Boolean = false) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): Playlist = JSON.decodeFromString(str)
  }
}

@Serializable
data class Pose(
  val poseId: Int = 0,
  val isLikeable: Boolean = false,
  val name: String? = null,
  val imageUrlSuffix: String = "",
  val libraryUrlSuffix: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): Pose = JSON.decodeFromString(str)
  }
}

@Serializable
data class PracticeResponse(
  val sequence: Sequence = Sequence(),
  val playlist: Playlist? = null,
  val sequenceStartTime: Duration? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): PracticeResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class Product(
  val productPeriod: ProductPeriod = ProductPeriod.MONTHLY,
  val productId: String = "",
  val currencyCode: String? = null,
  val price: String? = null,
  val yearlyPricePerMonth: String? = null,
  val appPrice: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): Product = JSON.decodeFromString(str)
  }
}

@Serializable
data class PurchaseMembershipResponse(
  val success: Boolean = false,
  val errorMessage: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): PurchaseMembershipResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class RedeemGiftResponse(
  val success: Boolean = false,
  val message: String? = null,
  val redirectUrl: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): RedeemGiftResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class RegenPlaylistResponse(
  val playlist: Playlist? = null,
  val errorMessage: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): RegenPlaylistResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class RequestUrls(
  val deleteUser: String = "",
  val forgotPassword: String = "",
  val latestPayment: String = "",
  val issueRefund: String = "",
  val setAutoRenew: String = "",
  val recordLinkClicked: String = "",
  val recordEvent: String = "",
  val recordProgress: String = "",
  val recordPracticeFinished: String = "",
  val recordPracticeStarted: String = "",
  val recordPlaylistStarted: String = "",
  val recordPurchase: String = "",
  val recordSongPlay: String = "",
  val recordFeedback: String = "",
  val recordSurveyAnswer: String = "",
  val recordTeaserOptionSelected: String = "",
  val regenPlaylist: String = "",
  val login: String = "",
  val logout: String = "",
  val signUp: String = "",
  val updateEmail: String = "",
  val unlinkFacebook: String = "",
  val unlinkGoogle: String = "",
  val unlinkApple: String = "",
  val updatePassword: String = "",
  val restorePurchases: String = "",
  val history: String = "",
  val historyDetails: String = "",
  val practice: String = "",
  val playlist: String = "",
  val message: String = "",
  val updateHistorySequenceFavorited: String = "",
  val renameHistorySequence: String = "",
  val deleteAllHistory: String = "",
  val deleteHistoryItem: String = "",
  val submitCode: String = "",
  val purchaseMembership: String = "",
  val purchaseGift: String = "",
  val redeemGift: String = "",
  val changePromotionalEmailStatus: String = "",
  val setSongFeedback: String = "",
  val sequenceLengths: String = "",
  val playbackUrl: String = "",
  val offlineUrl: String = "",
  val stitchProgress: String = "",
  val cancelStitch: String = "",
  val challengeEnroll: String = "") : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): RequestUrls = JSON.decodeFromString(str)
  }
}

@Serializable
data class RestorePurchasesResponse(
  val alertTitle: String? = null,
  val alertContent: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): RestorePurchasesResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class Sequence(
  val sequenceId: String = "",
  val poses: List<Pose> = listOf(),
  val poseTimes: List<Duration> = listOf(),
  val snapTimes: List<Duration> = listOf(),
  val postPracticeMessage: String = "",
  val postPracticePopUp: MessageResponse = MessageResponse(),
  val trackerLabel: String = "",
  val activityType: TrackerActivityType? = null,
  val readyOverlayStrings: List<String> = listOf(),
  val videoWidthToHeight: Double = 0.0,
  val skipButtonSizeToHeight: Double = 0.0,
  val skipButtonTopToHeight: Double = 0.0,
  val skipButtonRightToHeight: Double = 0.0,
  val totalTime: Duration = Duration.ZERO,
  val supportsPoseNames: Boolean = false,
  val supportsLikeAndExcludeButtons: Boolean = false,
  val supportsClosedCaptions: Boolean = false,
  val supportsCountdown: Boolean = false,
  val supportsOverlay: Boolean = false,
  val supportsMirror: Boolean = false,
  val supportsPoseTimeline: Boolean = false,
  val supportsAudioBalance: Boolean = false) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): Sequence = JSON.decodeFromString(str)
  }
}

@Serializable
data class SequenceLengthsResponse(
  val sequenceTokens: Map<Int, String> = mapOf(),
  val allPoses: List<Pose> = listOf(),
  val errorMessage: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): SequenceLengthsResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class SequenceUserProperties(
  var name: String = "",
  var favorite: Boolean = false) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): SequenceUserProperties = JSON.decodeFromString(str)
  }
}

@Serializable
data class SettingNode(
  val typeId: Int = 0,
  val defaultId: Int? = null,
  val options: List<SettingOption> = listOf()) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): SettingNode = JSON.decodeFromString(str)
  }
}

@Serializable
data class SettingOption(
  val id: Int = 0,
  val label: String = "",
  val groupLabel: String? = null,
  val helpText: String? = null,
  val audioUrl: String? = null,
  val videoUrl: String? = null,
  val imageUrl: String? = null,
  val songSamples: List<SongSample> = listOf(),
  val teaser: Boolean = false,
  val hideDuringOnboarding: Boolean = false,
  val mixConfig: MixConfig? = null,
  val displayViewPoses: Boolean? = null,
  val children: List<SettingNode> = listOf()) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): SettingOption = JSON.decodeFromString(str)
  }
}

@Serializable
data class SettingSelectorItem(
  val typeId: Int = 0,
  val label: String = "",
  val selectorTitle: String? = null,
  val selectorSubtitle: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): SettingSelectorItem = JSON.decodeFromString(str)
  }
}

@Serializable
data class SettingSelectorSection(
  val title: String = "",
  val items: List<SettingSelectorItem> = listOf()) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): SettingSelectorSection = JSON.decodeFromString(str)
  }
}

@Serializable
data class SignUpResponse(
  val cred: String = "") : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): SignUpResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class Song(
  val id: String = "",
  val title: String = "",
  val artist: String = "",
  val artwork: String = "",
  val itunesUrl: String? = null,
  val spotifyUrl: String? = null,
  val amazonUrl: String? = null,
  val previewUrl: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): Song = JSON.decodeFromString(str)
  }
}

@Serializable
data class SongSample(
  val id: String = "",
  val title: String = "",
  val artist: String = "",
  val url: String = "") : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): SongSample = JSON.decodeFromString(str)
  }
}

@Serializable
data class Status(
  val success: Boolean = false,
  val message: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): Status = JSON.decodeFromString(str)
  }
}

@Serializable
data class StitchProgressResponse(
  val completedProportion: Double = 0.0,
  val error: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): StitchProgressResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class StripeSessionResponse(
  val id: String? = null,
  val errorMessage: String? = null) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): StripeSessionResponse = JSON.decodeFromString(str)
  }
}

@Serializable
data class Subscription(
  val startDate: String = "",
  val endDate: String? = null,
  val description: String? = null,
  val membershipId: String? = null,
  val canSetAutoRenew: Boolean = false,
  val disableAutoRenewMessage: String? = null,
  val enableAutoRenewMessage: String? = null,
  val disableAutoRenewMessageTitle: String? = null,
  val planButtonText: String = "",
  val planButtonSubtext: String? = null,
  val planButtonUrl: String? = null,
  val paymentMethodText: String? = null,
  val paymentMethodSubtext: String? = null,
  val paymentMethodUrl: String? = null,
  val active: Boolean = false,
  val willBeChargedAgain: Boolean = false,
  val trial: Boolean = false) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): Subscription = JSON.decodeFromString(str)
  }
}

@Serializable
data class Survey(
  val id: Int = 0,
  val question: String = "",
  val surveyAnswers: List<String> = listOf(),
  val surveyAnswerIds: List<Int> = listOf()) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): Survey = JSON.decodeFromString(str)
  }
}

@Serializable
data class VideoQuality(
  val label: String = "",
  val id: Int = 0) : Response {

  override fun toJson() = JSON.encodeToString(this)

  companion object {

    fun fromJson(str: String): VideoQuality = JSON.decodeFromString(str)
  }
}
